import React from 'react';

const SpeechBubble = () => {
  return (
    <svg viewBox="0 0 385 177">
      <g id="ellipsis">
          <rect id="Rectangle" fill="#D8D8D8" x="0" y="0" width="385" height="177" rx="82.5"></rect>
          <circle id="Oval" fill="#737373" cx="97" cy="89" r="30"></circle>
          <circle id="Oval" fill="#737373" cx="187" cy="89" r="30"></circle>
          <circle id="Oval" fill="#737373" cx="277" cy="89" r="30"></circle>
      </g>
    </svg>
  )
}

export default SpeechBubble